import { useI18nContext } from "@hopper-b2b/i18n";

interface WatchTripSuccessProps {
  cn: (elementName: string) => string;
}

export const WatchTripSuccess = ({
  cn,
}: WatchTripSuccessProps): JSX.Element => {
  const {
    t,
    brand: { urls },
  } = useI18nContext();
  return (
    <div
      className={cn("success-view")}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      <p className={cn("subtitle")}>{t("priceWatch.successTitle")}</p>

      <p className={cn("description")}>{t("priceWatch.successMessage")}</p>

      <a
        className={cn("terms-and-conditions-link")}
        href={urls.termsAndConditions}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t("readTermsAndConditions")}
      </a>
    </div>
  );
};
